import { render, staticRenderFns } from "./InvoiceBatchSubTable.vue?vue&type=template&id=7385bde0&"
import script from "./InvoiceBatchSubTable.vue?vue&type=script&lang=ts&"
export * from "./InvoiceBatchSubTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports